/**
 *  Service to parse data to a object or object array 
 */
export default class DataUtils {
  /**
   * parses a data object to a specific class
   * e.g. Process
   * 
   * @param {*} data to parse
   * @param {*} ObjectClass class to assign data to
   * @returns parsed object of type Objectclass
   */
  static parseDataToSingleObject(data, ObjectClass) {
    return Object.assign(new ObjectClass(), data);
  }

  /**
   * parses an array of objects to an array of specific objects 
   * e.g. Process
   * 
   * @param {*} data array of data objects
   * @param {*} ObjectClass class to assign data to
   * @returns array of parsed objects of type ObjectClass
   */
  static parseDataToObjectArray(data, ObjectClass) {
    let parsedData = new Array()

    data.forEach((object) => {
      parsedData.push(Object.assign(new ObjectClass(), object));
    })

    return parsedData;
  }
}
